import React, { useEffect, useState } from "react";
import { URL_BASE } from "../../../constants";
import CloudIcon from "@mui/icons-material/Cloud";

export default function EnvironmentViewer() {
  const [activo, setActivo] = useState(false);
  const [message, setMessage] = useState("");
  const url = URL_BASE;

  useEffect(() => {
    if (url.includes("dev")) {
      setMessage("DEV");
      setActivo(true);
    } else if (url.includes("qa")) {
      setMessage("QA");
      setActivo(true);
    } else {
      setActivo(false);
    }
  }, [url]);

  const boxStyle = {
    display: "flex",
    borderRadius: "20px",
    width: "fit-content",
    padding: "0.6rem 1rem",
    margin: "0.5rem",
    backgroundColor: message === "QA" ? "#ffc107ff" : "#3553ffff",
  };

  const fontStyle = {
    fontSize: "1.2rem",
    fontWeight: "bold",
    fontFamily: "Arial, sans-serif",
    color: message === "QA" ? "#222" : "#FFF",
    // padding: ".2rem .4rem",
    margin: "auto",
  };

  return (
    <div style={activo ? boxStyle : {}}>
      {activo && (
        <h2 style={fontStyle}>
          <CloudIcon style={{ marginRight: "6px", fontSize: "1.2rem" }} />
          {message}
        </h2>
      )}
    </div>
  );
}
